import { defineAsyncComponent } from 'vue';
import { createVNodeFunction } from '@uselab/vue-islands';

export const components = {
  projectMap: createVNodeFunction(
    defineAsyncComponent(() => import('@/components/project-map/index.vue'))
  ),
  mijnYmereMenu: createVNodeFunction(
    defineAsyncComponent(() => import('@/components/mijn-ymere-menu/index.vue'))
  ),
};
